import NoItemImage from '../../assets/image/emptyList.png';

const NoItemFoundPage = ({
  className = 'h-[90dvh]',
  title = 'موردی وجود ندارد',
}: {
  className?: string;
  title?: string;
}) => {
  return (
    <div
      className={`${className} w-full gap-4 flex flex-col justify-center items-center text-gray-600`}
    >
      <img src={NoItemImage}></img>
      <div>{title}</div>
    </div>
  );
};

export default NoItemFoundPage;
